import { render, staticRenderFns } from "./EquivalencesFilters.vue?vue&type=template&id=0036b342&scoped=true&"
import script from "./EquivalencesFilters.vue?vue&type=script&lang=js&"
export * from "./EquivalencesFilters.vue?vue&type=script&lang=js&"
import style0 from "./EquivalencesFilters.vue?vue&type=style&index=0&id=0036b342&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0036b342",
  null
  
)

export default component.exports